function initializeStickyButtons() {
  const buttons = [];
  document.querySelectorAll('.frame-type-sitepackage_stickybutton').forEach(frame => {
    const link = frame.querySelector('a[href]');
    if (!link) return;
    try {
      const url = new URL(link.href, window.location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search || !url.hash) return;
      const target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
      if (target && target !== frame && !frame.contains(target)) buttons.push({frame, target});
    } catch {
      // Keep links with an invalid or missing fragment visible.
    }
  });
  if (!buttons.length) return;

  let scheduled = false;
  const update = () => {
    scheduled = false;
    buttons.forEach(({frame, target}) => {
      frame.hidden = target.getBoundingClientRect().top <= window.innerHeight;
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('load', schedule);
  const observer = new ResizeObserver(schedule);
  observer.observe(document.body);
  update();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeStickyButtons, {once: true});
} else {
  initializeStickyButtons();
}
